import { render, staticRenderFns } from "./NotificationDetails.vue?vue&type=template&id=79d895e4&scoped=true"
import script from "./NotificationDetails.vue?vue&type=script&lang=js"
export * from "./NotificationDetails.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetails.vue?vue&type=style&index=0&id=79d895e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d895e4",
  null
  
)

export default component.exports